(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
    if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', function(){
            if(event.target.classList.contains('swiper-slide')){
                const collectionListSwiperEl = event.target.closest('.swiper.collection-list-slider');
                let slideIndex = event.target.dataset.index;
                if(collectionListSwiperEl){
                    collectionListSwiperEl.swiper.slideTo(slideIndex);
                }
            }
        });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"]) return;
  try {
    

    if (!Shopify.designMode){
        if (!localStorage.getItem('popupDisplayed')) {
            setTimeout(function(){
                popupShow()
                localStorage.setItem('popupDisplayed', true);
            }, 5000)
        }
        const newsletterPopup = document.getElementById('newsletter-popup');
        const popupCloseBtn = newsletterPopup.querySelector('.popup-close');
        const popupCancelBtn = newsletterPopup.querySelector('.popup-cancel');
        popupCloseBtn.addEventListener('click', function(){
            popupClose()
        });
        popupCancelBtn.addEventListener('click', function(){
            popupClose()
        });
        document.addEventListener('click', function(event) {
            const popupCard = newsletterPopup.querySelector('.popup-card');
            if (!popupCard.contains(event.target)) {
                popupClose();
            }
        });
        document.addEventListener("DOMContentLoaded", function() {
            if (window.location.hash === '#popupContactForm') {
                popupShow();
            }
        });
    }

    if(Shopify.designMode){
        document.addEventListener('shopify:section:select', function(){
            const sectionSelected = event.target.classList.contains('popup-section');
            if(sectionSelected){
                popupShow();
            }
        })
        document.addEventListener('shopify:section:deselect', function(){
            const sectionSelected = event.target.classList.contains('popup-section');
            if(sectionSelected){
                popupClose();
            }
        })
        document.addEventListener('shopify:section:unload', function(){
            const sectionSelected = event.target.classList.contains('popup-section');
            if(sectionSelected){
                const htmlEl = document.querySelector('html');
                htmlEl.classList.remove('popup-show');
            }
        })
    }

    function popupShow() {
        const htmlEl = document.querySelector('html');
        const newsletterPopup = document.getElementById('newsletter-popup');
        const popupCard = newsletterPopup.querySelector('.popup-card');
        newsletterPopup.classList.add('show');
        htmlEl.classList.add('popup-show');
        if(Shopify.designMode){
            newsletterPopup.classList.add('fade');
        }
        setTimeout(function() {
            newsletterPopup.classList.add('fade');
            if(!Shopify.designMode){
                popupCard.focus();
            }
        }, 100);

        // Trap focus within the popup card
        popupCard.setAttribute('tabindex', '-1');
        popupCard.addEventListener('keydown', function(event) {
            trapFocus(event, popupCard);
        });
    }

    function popupClose() {
        const htmlEl = document.querySelector('html');
        const newsletterPopup = document.getElementById('newsletter-popup');
        newsletterPopup.classList.remove('fade');
        setTimeout(function() {
            newsletterPopup.classList.remove('show');
            htmlEl.classList.remove('popup-show');
        }, 400);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.handleIntersection = this.handleIntersection.bind(this);
      this.recommendationSectionSlider = this.recommendationSectionSlider.bind(this);
      this.intersectionCompleted = false;
    }

    connectedCallback() {
      this.intersectionObserver = new IntersectionObserver(
        this.handleIntersection,
        { rootMargin: '0px 0px 200px 0px' }
      );
      this.intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
    }

    handleIntersection(entries, observer) {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);

      const url = this.dataset.url;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            handleQuickView();
          }
          this.intersectionCompleted = true; // Set the flag to true after completion
          if(html.querySelector('.recommendation-list-slider')){
            this.recommendationSectionSlider();
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
    recommendationSectionSlider(){
        if (!this.intersectionCompleted) return;
        const featureSlider = this.querySelector('.recommendation-list-slider');
        const section = '#' + featureSlider.id;
        const prevBtn = featureSlider.closest('product-recommendations').querySelector('.slider-btn-prev');
        const nextBtn = featureSlider.closest('product-recommendations').querySelector('.slider-btn-next');
        const dtSlides = featureSlider.dataset.desktopSlides;
        const sdtSlides = featureSlider.dataset.smalldesktopSlides;
        const ltSlides = featureSlider.dataset.laptopSlides;
        const tbSlides = featureSlider.dataset.tabletSlides;
        const mbSlides = featureSlider.dataset.mobileSlides;
        this.recommendationListSlider(section, prevBtn, nextBtn, dtSlides, sdtSlides, ltSlides, tbSlides, mbSlides);
    }
    recommendationListSlider(section, prevBtn, nextBtn, dtSlides, sdtSlides, ltSlides, tbSlides, mbSlides) {
        try {
          let swiper = new Swiper(section, {
                spaceBetween: 20,
                slidesPerView: mbSlides,
                allowTouchMove: true,
                navigation: {
                  prevEl: prevBtn,
                  nextEl: nextBtn
                },
                clickable: true,
                breakpoints: {
                  520: {
                    slidesPerView: mbSlides,
                  },
                  768: {
                    slidesPerView: tbSlides,
                  },
                  1024: {
                    slidesPerView: ltSlides,
                  },
                  1280: {
                    slidesPerView: sdtSlides,
                  },
                  1536: {
                    slidesPerView: dtSlides,
                  },
                },
                on: {
                  init: function () {
                    
                    $(section).removeAttr('x-swiper');
                  },
                }
            });
        } catch (e) {
            console.log('Swiper JS is not defined');
            console.log(e);
        }
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  let vedio_count = document.querySelectorAll('.video-section');
  for (i = 0; i < vedio_count.length; i++) {
    let section_id = vedio_count[i].dataset.id;
    let button = document.querySelector('#video-section-btn-' + section_id);
    let template = document.querySelector('#template-' + section_id).content;
    let targetDiv = document.querySelector('#video-' + section_id);
    let deferred_media = document.querySelector('#deferred-media-' + section_id);

    button.addEventListener('click', function () {
      let clonedTemplate = template.cloneNode(true);
      targetDiv.appendChild(clonedTemplate);
      deferred_media.setAttribute('loaded', true);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
